/*eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import { default as PanoModule } from "Components/Panorama/PanoPlayer";

import { createUseStyles } from "react-jss";
import styles from "./styles";

const EventEmitter = require('eventemitter3')

const CursorState = {
  GRAB: "grab",
  GRABBING: "grabbing",
};

const PanoPlayer = React.forwardRef((props: any, ref: any) => {
  const {
    options,
    play,
    changeMode,
    fullScreen,
    changeFullScreen,
    children,
    changePanoFullScreen,
  } = props;
  const [cursor, setCursor] = useState(CursorState.GRAB);
  const [resize, setResize] = useState(null);
  const useStyles = createUseStyles(styles);
  const classes = useStyles({ ...props });

  const panoPlayer = useRef(null);

  const handleOnClick = () => {
    setCursor(CursorState.GRABBING);
  };

  const setAutoRotate = ({ auto, speed }) =>
    panoPlayer?.current?.setAutoRotate(auto, speed);

  const setPanoViewer = (width, height) => {
    const handleViewReady = () => {
      setAutoRotate({
        auto: true,
        speed: 0.1,
      });
    };
    const handleOnMouseUp = () => {
      setCursor(CursorState.GRAB);
      changeMode();
    };

    const eventEmitter = new EventEmitter();
    eventEmitter.on("viewReady", handleViewReady);
    eventEmitter.on("mouseup", handleOnMouseUp);
    options.width = width;
    options.height = height;
    panoPlayer.current = new PanoModule({
      ...options,
      selector: ref.current,
      eventEmitter,
      clearSelectorHTML: false,
    });
  };

  useEffect(() => {
    const exitHandler = (e: any) => {
      //fullscreenElement is not supported in IE 11
      //https://developer.mozilla.org/en-US/docs/Web/API/Fullscreen_API
      if (
        !document.fullscreenElement &&
        !document["webkitIsFullScreen"] &&
        !document["mozFullScreen"] &&
        !document["msFullscreenElement"]
      ) {
        changeFullScreen(false);
        changePanoFullScreen(false);
        panoPlayer.current.setFullscreen(false);
        panoPlayer.current.setSize("1341", "683");
      }
    };

    const orientationChange = (e: any) => {
      setResize(window.orientation);
    };

    document.addEventListener("fullscreenchange", exitHandler);
    document.addEventListener("webkitfullscreenchange", exitHandler);
    document.addEventListener("mozfullscreenchange", exitHandler);
    document.addEventListener("MSFullscreenChange", exitHandler);
    window.addEventListener("orientationchange", orientationChange);

    return () => {
      document.removeEventListener("fullscreenchange", exitHandler);
      document.removeEventListener("webkitfullscreenchange", exitHandler);
      document.removeEventListener("mozfullscreenchange", exitHandler);
      document.removeEventListener("MSFullscreenChange", exitHandler);
      window.removeEventListener("orientationchange", orientationChange);
    };
  }, []);

  useEffect(() => {
    if (panoPlayer.current) {
      if (fullScreen) {
        panoPlayer.current.setFullscreen(fullScreen);
        changePanoFullScreen(true);
      } else {
        changeFullScreen(false);
        changePanoFullScreen(false);
        panoPlayer.current.setFullscreen(false);
        panoPlayer.current.setSize("1341", "683");
      }
    }
  }, [fullScreen]);

  useEffect(() => {
    setPanoViewer(ref.current.clientWidth, ref.current.clientHeight);
    panoPlayer.current.embed();

    return () => {
      panoPlayer?.current?.destroy();
    };
  }, [options.path]);

  useEffect(() => {
    if (resize !== null) {
      panoPlayer?.current?.destroy();
      setPanoViewer("100%", "100%");
      panoPlayer.current.embed();
    }
  }, [resize]);

  useEffect(() => {
    panoPlayer?.current?.setAutoRotate(play, 0.1);
  }, [play]);

  return (
    <div
      ref={ref}
      className={classes.panoContainer}
      style={{
        cursor,
      }}
    >
      {children}
    </div>
  );
});

export default PanoPlayer;
